import { Grid, TextField, MenuItem, Box } from '@mui/material';
import { DEPARTMENTS, DESIGNATIONS, EMPLOYMENT_TYPES } from '@/mock/teachers';

export function ProfessionalInfoStep({ formik }) {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Employee ID"
            name="employeeId"
            value={formik.values.employeeId}
            onChange={formik.handleChange}
            error={formik.touched.employeeId && Boolean(formik.errors.employeeId)}
            helperText={formik.touched.employeeId && formik.errors.employeeId}
            required
          />
        </Grid>
        
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Joining Date"
            type="date"
            name="joiningDate"
            slotProps={{ inputLabel: { shrink: true } }}
            value={formik.values.joiningDate}
            onChange={formik.handleChange}
            required
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            select
            label="Department"
            name="department"
            value={formik.values.department}
            onChange={formik.handleChange}
            required
          >
            {DEPARTMENTS.map((dept) => (
              <MenuItem key={dept} value={dept}>{dept}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            select
            label="Designation"
            name="designation"
            value={formik.values.designation}
            onChange={formik.handleChange}
            required
          >
            {DESIGNATIONS.map((desig) => (
              <MenuItem key={desig} value={desig}>{desig}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            select
            label="Employment Type"
            name="employmentType"
            value={formik.values.employmentType}
            onChange={formik.handleChange}
          >
            {EMPLOYMENT_TYPES.map((type) => (
              <MenuItem key={type} value={type}>{type}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Qualification"
            name="qualification"
            value={formik.values.qualification}
            onChange={formik.handleChange}
            placeholder="e.g. M.Sc. Mathematics, B.Ed."
            required
          />
        </Grid>
        
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Previous Experience"
            name="experience"
            value={formik.values.experience}
            onChange={formik.handleChange}
            placeholder="e.g. 5 years"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
